export interface IPesquisaConvenio {
    codigo: number;
    nome: string;
}   

export const defValueConvenio: IPesquisaConvenio = {
    codigo: 0,
    nome: ""
}